import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;

// Published content pages plus the Partners page (inserted after About Us) when enabled.
export const useNavPages = () => {
  const [items, setItems] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    Promise.all([
      axios.get(`${API}/pages`).then(r => r.data || []).catch(() => []),
      axios.get(`${API}/settings/partners-page`).then(r => r.data?.enabled).catch(() => false),
    ]).then(([pages, partnersOn]) => {
      const list = pages.map(p => ({ id: p.id, title: p.title, slug: p.slug, to: `/page/${p.slug}` }));
      if (partnersOn) {
        const at = list.findIndex(p => p.slug === 'about-us');
        list.splice(at >= 0 ? at + 1 : 0, 0, { id: 'partners', title: 'Partners', slug: 'partners', to: '/partners' });
      }
      cache = list;
      setItems(list);
    });
  }, []);
  return items;
};
